import {
  Checkbox,
  Divider,
  FormControlLabel,
  Grid,
  IconButton,
  styled,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Releasenotescoverpicture from "../../assets/images/Releasenotescoverpicture.svg";
import { Close } from "@mui/icons-material";
import PropTypes from "prop-types";
import TextLabel from "components/Common/TextLabel/TextLabel";
import { getReleaseUpdates } from "services/userServices";
import moment from "moment";
import BackdropComponent from "components/Spinner/Spinner";
const ScrollableGrid = styled(Grid)(({ theme }) => ({
  height: "calc(100vh - 200px)", // Adjust height as needed
  overflow: "auto",
  "&::-webkit-scrollbar": {
    width: "12px",
  },
  "&::-webkit-scrollbar-track": {
    background: "#f1f1f1",
  },
  "&::-webkit-scrollbar-thumb": {
    background: "#888",
    borderRadius: "10px",
  },
  "&::-webkit-scrollbar-thumb:hover": {
    background: "#555",
  },
}));

const UpdateCard = ({ title, date, description }) => (
  <Grid container>
    <Grid item xs={8} sx={{ paddingLeft: 2, paddingRight: 2 }}>
      <TextLabel text={title} subHeading fontSize={16}></TextLabel>
    </Grid>
    <Grid item xs={2}></Grid>
    <Grid item xs={2} sx={{ paddingLeft: 2, paddingRight: 2 }}>
      <TextLabel text={date} subHeading fontSize={16}></TextLabel>
    </Grid>
    <Grid item xs={12} sx={{ paddingLeft: 2, paddingRight: 2 }}>
      <TextLabel text={description} description fontSize={14}></TextLabel>
    </Grid>
    <Grid item xs={12} sx={{ padding: 2 }}>
      <Divider />
    </Grid>
  </Grid>
);

UpdateCard.propTypes = {
  title: PropTypes.string,
  date: PropTypes.string,
  description: PropTypes.string,
};

export default function ReleaseUpdates(props) {
  const [loading, setLoading] = useState(false);
  const [isChecked, setIsChecked] = React.useState(
    localStorage.getItem("doNotShowReleaseNotesAgain") === "true",
  );
  const [releaseUpdates, setReleaseUpdates] = useState([]);

  useEffect(() => {
    let cancelled = false;

    const fetchData = async () => {
      if (!cancelled) {
        setLoading(true);
      }

      try {
        const response = await getReleaseUpdates();

        if (cancelled) return;

        if (response.statusCode === 200) {
          if (!cancelled) {
            setReleaseUpdates(
              response.data.map((item) => ({
                ...item,
                id: item?.ReleaseUpdatesId,
              })),
            );
          }
        }
      } catch (error) {
        if (!cancelled) {
          console.error("Failed to fetch release updates:", error);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    fetchData();

    return () => {
      cancelled = true;
    };
  }, []);

  const handleDoNotShowReleaseNotesAgain = () => {
    const previousValue = isChecked;
    setIsChecked(!isChecked);
    localStorage.setItem("doNotShowReleaseNotesAgain", !isChecked);
    if (!previousValue) props.onClose();
  };
  return (
    <>
      {loading ? <BackdropComponent /> : null}
      <Grid container>
        <Grid
          item
          xs={12}
          id="header-card"
          sx={{
            position: "sticky",
            top: 0,
            zIndex: 1, // Ensure it stays on top
            backgroundColor: "white", // Ensure background color to avoid overlap issues
          }}
        >
          <Grid container>
            <Grid item xs={12} sx={{ padding: 2 }}>
              <Grid container>
                <Grid item xs={11.5}>
                  <TextLabel
                    text="What's New in ASTT ?"
                    header
                    fontSize={18}
                  ></TextLabel>
                </Grid>
                <Grid item xs={0.5}>
                  <IconButton onClick={props.onClose}>
                    <Close sx={{ color: "#3299ff" }} />
                  </IconButton>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sx={{
                    backgroundColor: "#3299ff",
                    borderRadius: "10px",
                    marginTop: 1.2,
                  }}
                >
                  <img
                    src={Releasenotescoverpicture}
                    alt="Release updates"
                  ></img>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid>
            {props.newUpdatesAvailable ? (
              <>
                <Grid item xs={9.2}></Grid>
                <Grid item xs={2.8} sx={{ padding: 1 }}>
                  <FormControlLabel
                    control={<Checkbox checked={isChecked} />}
                    onChange={handleDoNotShowReleaseNotesAgain}
                    label={
                      <Typography
                        sx={{
                          fontFamily: "Urbanist, Verdana, Arial, sans-serif",
                          fontSize: 14,
                          fontWeight: "bold",
                          letterSpacing: "0.10em",
                          color: "#3F5765",
                          paddingLeft: 1,
                        }}
                      >
                        Don't show again
                      </Typography>
                    }
                  ></FormControlLabel>
                </Grid>
              </>
            ) : (
              <Grid item xs={12} sx={{ padding: 1 }}></Grid>
            )}
          </Grid>
        </Grid>
        <ScrollableGrid
          item
          xs={12}
          id="item-list"
          sx={{
            height: "calc(100vh - 350px)", // Adjust height as needed
            overflow: "auto",
          }}
        >
          <Grid container>
            {releaseUpdates.map((update) => (
              <Grid item xs={12} key={update.Title}>
                <UpdateCard
                  title={update.Title}
                  date={moment(update.Date).format("MM-DD-YYYY")}
                  description={update.Description}
                ></UpdateCard>
              </Grid>
            ))}
          </Grid>
        </ScrollableGrid>
      </Grid>
    </>
  );
}

ReleaseUpdates.propTypes = {
  onClose: PropTypes.func,
  newUpdatesAvailable: PropTypes.bool,
};
